export enum TSSchadenfallEvent {
    GESUCH_DURCH_BEROFFENER_FREIGEGEBEN = <any>'GESUCH_DURCH_BEROFFENER_FREIGEGEBEN',
    PAPIERGESUCH_DURCH_ANLAUFSTELLE_FREIGEGEBEN = <any>'PAPIERGESUCH_DURCH_ANLAUFSTELLE_FREIGEGEBEN',
    ANLAUFSTELLE_BASISPRUEFUNG_OK = <any>'ANLAUFSTELLE_BASISPRUEFUNG_OK',
    STICHENTSCHEID_ANGEFORDERT = <any>'STICHENTSCHEID_ANGEFORDERT',
    ABLEHNUNG = <any>'ABLEHNUNG',
    SCHAETZUNG_DURCHGEFUEHRT = <any>'SCHAETZUNG_DURCHGEFUEHRT',
    ANLAUFSTELLE_SCHAETZUNG_OK = <any>'ANLAUFSTELLE_SCHAETZUNG_OK',
    ZURUECK_AN_SCHAETZER = <any>'ZURUECK_AN_SCHAETZER',
    FS_UEBERPRUEFUNG_OK = <any>'FS_UEBERPRUEFUNG_OK',
    FS_UEBERPRUEFUNG_OK_PAPIER = <any>'FS_UEBERPRUEFUNG_OK_PAPIER',
    FS_UEBERPRUEFUNG_MANGELHAFT = <any>'FS_UEBERPRUEFUNG_MANGELHAFT',
    WIEDERHERSTELLUNG_AUSGEFUEHRT = <any>'WIEDERHERSTELLUNG_AUSGEFUEHRT',
    WIEDERHERSTELLUNG_MANGELHAFT = <any>'WIEDERHERSTELLUNG_MANGELHAFT',
    WIEDERHERSTELLUNG_GEPRUEFT = <any>'WIEDERHERSTELLUNG_GEPRUEFT',
    WIEDERHERSTELLUNG_GEPRUEFT_PAPIER = <any>'WIEDERHERSTELLUNG_GEPRUEFT_PAPIER',
    ABRECHNUNG_MANGELHAFT = <any>'ABRECHNUNG_MANGELHAFT',
    ABRECHNUNG_OK = <any>'ABRECHNUNG_OK',
    ZAHLUNG_AUSGELOEST = <any>'ZAHLUNG_AUSGELOEST',
    STICHENTSCHEID_OK = <any>'STICHENTSCHEID_OK',
    FREIGABE_PAPIER_FS_6 = <any>'FREIGABE_PAPIER_FS_6',
    FREIGABE_PAPIER_FS_9 = <any>'FREIGABE_PAPIER_FS_9',
    LOESCHEN = <any>'LOESCHEN',

}

export function getTSSchadenfallEventValues(): Array<TSSchadenfallEvent> {
    return [
        TSSchadenfallEvent.GESUCH_DURCH_BEROFFENER_FREIGEGEBEN,
        TSSchadenfallEvent.PAPIERGESUCH_DURCH_ANLAUFSTELLE_FREIGEGEBEN,
        TSSchadenfallEvent.ANLAUFSTELLE_BASISPRUEFUNG_OK,
        TSSchadenfallEvent.STICHENTSCHEID_ANGEFORDERT,
        TSSchadenfallEvent.ABLEHNUNG,
        TSSchadenfallEvent.SCHAETZUNG_DURCHGEFUEHRT,
        TSSchadenfallEvent.ANLAUFSTELLE_SCHAETZUNG_OK,
        TSSchadenfallEvent.FS_UEBERPRUEFUNG_OK,
        TSSchadenfallEvent.FS_UEBERPRUEFUNG_OK_PAPIER,
        TSSchadenfallEvent.FS_UEBERPRUEFUNG_MANGELHAFT,
        TSSchadenfallEvent.WIEDERHERSTELLUNG_AUSGEFUEHRT,
        TSSchadenfallEvent.WIEDERHERSTELLUNG_MANGELHAFT,
        TSSchadenfallEvent.WIEDERHERSTELLUNG_GEPRUEFT,
        TSSchadenfallEvent.WIEDERHERSTELLUNG_GEPRUEFT_PAPIER,
        TSSchadenfallEvent.ABRECHNUNG_MANGELHAFT,
        TSSchadenfallEvent.ABRECHNUNG_OK,
        TSSchadenfallEvent.ZAHLUNG_AUSGELOEST,
        TSSchadenfallEvent.ABLEHNUNG,
        TSSchadenfallEvent.STICHENTSCHEID_OK,
        TSSchadenfallEvent.FREIGABE_PAPIER_FS_6,
        TSSchadenfallEvent.FREIGABE_PAPIER_FS_9,
        TSSchadenfallEvent.LOESCHEN,

    ];
}



// WEBPACK FOOTER //
// ./src/app/models/enums/TSSchadenfallEvent.ts